import { BasePessoaModel } from "../base/base-pessoa-model";
import { ComponenteSistemaType } from "../../types"

export class TenantComponenteModel extends BasePessoaModel {    
    public tenantId: string;
    public codigoItem: string;    
    public nome: string;    
    public tipoItem: ComponenteSistemaType;
    public quantidade: number
}